import * as React from 'react';
import { ErrorMessage, Field } from 'formik';
import style from './style.module.scss';
import capitalize from 'react-bootstrap/lib/utils/capitalize';
import cx from 'classnames';

interface FieldInputProps {
  autoComplete?: string;
  name: string;
  type: string;
  id?: string;
  label?: string;
  optional?: boolean;
  hint?: string;
  errorName?: string;
  className?: string;
  onKeyUp?: (e: any) => void;
  placeholder?: string;
  hideLabel?: boolean;
}

export function FieldInput(props: FieldInputProps) {
  return (
    <div className={'u-margin-T-s'}>
      {!props.hideLabel && <label htmlFor={id(props)}>
        {capitalize(props.label || props.name)}{' '}
        {props.optional && (
          <span className={style.optional}>
            <small>(Optional)</small>
          </span>
        )}
      </label>}

      <div>
        <Field
          autoComplete={props.autoComplete}
          name={props.name}
          id={id(props)}
          type={props.type}
          className={cx('form-control', props.className)}
          component={props.type === 'textarea' ? 'textarea' : 'input'}
          onKeyUp={props.onKeyUp}
          placeholder={props.placeholder}
        />
      </div>
      {props.hint && (
        <p>
          <small>{props.hint}</small>
        </p>
      )}
      <div className={style.errorMessage}>
        <ErrorMessage name={props.name} />
      </div>
    </div>
  );
}

function id(props: FieldInputProps) {
  return props.id || `${props.name}-input`;
}
